import styled from 'styled-components'

export const Container = styled.div`
	padding: 2rem 1rem 3rem 1rem;

	@media(max-width: 440px) {
		padding: 1rem 0 0;
	} 

	h2 {
		font-size: 16px;
		font-weight: 800;
	}

	.form-add-exame {
		.input-crm {
			width: 354px;
		}

		.input-data-exame,
		.input-data-resultado {
			width: 180px;
		}

		.input-tipo {
			width: 320px;
		}

		.input-exame,
		.input-medico,
		.input-especialidade {
			max-width: 450px;
		}

		@media(max-width: 900px) {
			.input-tipo,
			.input-crm,
			.input-data-exame,
			.input-data-resultado,
			.input-exame,
			.input-medico,
			.input-especialidade {
				max-width: unset;
				width: 100%;
			}
		}
	}
`

export const DropdownVariacoesContainer = styled.div`
	width: 300px;

	@media(max-width: 600px) {
		width: calc(100vw - 42px);
	}
`
